'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Air = require('./Air');

var _Air2 = _interopRequireDefault(_Air);

var _Car = require('./Car');

var _Car2 = _interopRequireDefault(_Car);

var _Hotel = require('./Hotel');

var _Hotel2 = _interopRequireDefault(_Hotel);

var _Container = require('./Container');

var _Container2 = _interopRequireDefault(_Container);

var _ContainerNoProps = require('./ContainerNoProps');

var _ContainerNoProps2 = _interopRequireDefault(_ContainerNoProps);

var _InputText = require('./InputText');

var _InputText2 = _interopRequireDefault(_InputText);

var _Textarea = require('./Textarea');

var _Textarea2 = _interopRequireDefault(_Textarea);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _RailCard = require('./RailCard');

var _RailCard2 = _interopRequireDefault(_RailCard);

var _Tabs = require('./Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Air: _Air2.default,
    Car: _Car2.default,
    Hotel: _Hotel2.default,
    Container: _Container2.default,
    ContainerNoProps: _ContainerNoProps2.default,
    InputText: _InputText2.default,
    Textarea: _Textarea2.default,
    Label: _Label2.default,
    RailCard: _RailCard2.default,
    Tabs: _Tabs2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/index.js
// module id = 1566
// module chunks = 0